import  { useEffect, useState, useCallback } from 'react';
import { getComentarioByDenunciaID } from '../../services/comentarioDenunciaService';
import { getUserInfoById } from '../../services/userService';
import './detallesReporte.css';
import iconoUsuario from '../../assets/user.png';
import iconoTelefono from '../../assets/telefono.png';
import iconoCorreo from '../../assets/correo.png';

import { useUser } from '../../userContext';

const DetallesReporte = ({ datosDenuncia, onClose }) => {
    const [comentarios, setComentarios] = useState([]);

    const { token } = useUser();
    const [usuario, setUsuario] = useState({});
    const getEstatusClass = (estatus) => {
        switch (estatus) {
            case 'Capturado':
                return 'capturado-title';
            case 'En revisión':
                return 'revision-title';
            case 'Atendida':
                return 'atendida-title';
            default:
                return '';
        }
    };

    const fetchData = useCallback(async () => {
        try {
            let data = await getComentarioByDenunciaID({ token, denunciaID: datosDenuncia.id });
            setComentarios(data);
        } catch (error) {
            console.error('Error:', error);
        }
        //si el id es 0 no se hace la peticion
        if (datosDenuncia.userID === 0) {
            return;
        }
        try {
            let data = await getUserInfoById({ token, id: datosDenuncia.userID});
            setUsuario(data);
        } catch (error) {
            console.error('Error:', error);
        }
    }, [datosDenuncia.id, datosDenuncia.userID]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);


    //formatear fecha y hora del createdAt recibe la fecha y la convierte a dd/mm/yyyy hh:mm
    //recibe algo asi: 2024-10-21 11:10:45.034-06
    const formatearFecha = (fecha) => {
        const fechaHora = fecha.split('T');
        const fechaArray = fechaHora[0].split('-');
        let horaArray = fechaHora[1].split(':');
        //QUITARLE 6 HORAS A LA HORA
        horaArray[0] = horaArray[0] - 6;
        return `${fechaArray[2]}/${fechaArray[1]}/${fechaArray[0]} ${horaArray[0]}:${horaArray[1]}`;
    };

    return (
        <div class="popup">
            <div class="popup-blur" onClick={onClose}></div>
            <div key={datosDenuncia.id} className={`denuncia-card-detalles ${getEstatusClass(datosDenuncia.estatus)}`}>
                <div className={`denuncia-status ${getEstatusClass(datosDenuncia.estatus)}`}>{datosDenuncia.estatus}</div>
                <div className="popup-card">
                    <div className='contenedor-fecha-estatus'>
                        <div className='denuncia-fecha'>{formatearFecha(datosDenuncia.createdAt)}</div>
                        <div className='denuncia-noficio'>N.Folio {datosDenuncia.id}</div>
                        <div className="denuncia-tipo">{datosDenuncia.tipo}</div>
                    </div>
                    {/*si el id es 0 no se muestra el nombre del usuario y se dice que el usuario es anonimo*/}
                    {datosDenuncia.userID === 0 ? (
                        <div className='contenedor-user-info-detalles'>
                            <div className='popup-usuario'>
                                <img src={iconoUsuario} className='icono-usuario-detalles' alt='usuario icono' />
                                Usuario anónimo
                            </div>
                            <div className='popup-usuario'>
                                <img src={iconoTelefono} className='icono-usuario-detalles' alt='telefono icono' />
                                {datosDenuncia.telefono === '' ? 'Sin teléfono' : datosDenuncia.telefono}
                            </div>
                        </div>
                    ) : (
                        <div className='contenedor-user-info-detalles'>
                            <div className='popup-usuario'>
                                <img src={iconoUsuario} className='icono-usuario-detalles' alt='usuario icono' />
                                {usuario.nombre} {usuario.apellido1} {usuario.apellido2}
                            </div>
                            <div className='popup-usuario'>
                                <img src={iconoTelefono} className='icono-usuario-detalles' alt='telefono icono' />
                                {usuario.telefono}
                            </div>
                            <div className='popup-usuario'>
                                <img src={iconoCorreo} className='icono-usuario-detalles' alt='correo icono' />
                                {usuario.correo}
                            </div>
                        </div>
                    )}
                    <div className='popup-titulo'>{datosDenuncia.titulo}</div>
                    <div className='popup-descripcion'>{datosDenuncia.descripcion}</div>
                    <div className='popup-denuncia-fotos'>
                        {datosDenuncia.imagenes.split(',').map((imagen, index) => (
                            <img
                                key={index}
                                src={`${process.env.REACT_APP_URL_API2}/api/uploads/${imagen}`}
                                alt='imagen de la denuncia'
                                className='popup-denuncia-foto'
                            />
                        ))}
                    </div>
                    <div className='popup-denuncia-ubicacion'>ubicación {datosDenuncia.coordenadas}</div>
                    <div className='popup-comentarios'>
                        <div className='comentarios-titulo'>Comentarios</div>
                        {comentarios.length === 0 && <div className='no-comentarios'>No hay comentarios...</div>}
                        {comentarios.map((comentario, index) => (
                            <div
                                key={index}
                                className={`denuncia-comentario ${comentario.enviadoPorUsuario ? 'mensaje-usuario' : ''}`}
                            >
                                <div className='comentario-texto'>
                                    <div className='comentario-fecha'>
                                        {formatearFecha(comentario.createdAt)}
                                    </div>
                                    {comentario.enviadoPorUsuario && "Usuario: "}
                                    {comentario.enviadoPorConvenio && "Convenio: "}
                                    {comentario.enviadoPorPolicia && "Policía: "}
                                    {comentario.comentario}
                                </div>
                                {comentario.imagenes === 'sin imagenes' ? (
                                    <>
                                        {/*<div className='comentario-foto'>No hay fotos</div>*/}
                                    </>
                                ) : (
                                    comentario.imagenes.split(',').map((imagen, index) => (
                                        <img
                                            key={index}
                                            src={`${process.env.REACT_APP_URL_API2}/api/uploads2/${imagen}`}
                                            alt='imagen del comentario'
                                            className='comentario-foto'
                                        />
                                    ))
                                )}

                            </div>
                        ))}
                    </div>
                    <button className='boton-primario' onClick={onClose}>Aceptar</button>
                </div>
            </div>
        </div >
    );
};

export default DetallesReporte;
